import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Font from './Font';   // font-size
import Size from './Size';    // button size
import Color from './Color';  // button color

export const Button = styled.button`
  margin: 0;
  padding: 0;
  border: 1px solid;
  border-radius: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease-out;
  
  ${props => Size(props.size)};
  ${props => Color(props.color)};
  ${props => props.size === 'xl' ? Font('lg') : 
             props.size === 'fullWidth' ? Font('md') : 
             props.size === 'sm' ? Font('md') : 
             props.size === 'xs' ? Font('sm') : 
             Font(props.size)};

  &:disabled {
    color: #d1d1d1;
    border: 1px solid #dfdfdf;
    background-color: #f7f7f7;
    cursor: default;

    &:hover {
      color: #d1d1d1;
      border-color: #dfdfdf;
      background-color: #f7f7f7;
    }
    &:active {
      color: #d1d1d1;
      border-color: #dfdfdf;
      background-color: #f7f7f7;
    }
  }
`

export const LinkBtn = styled(Link)`
  display: inline-block;
  width: 100%;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border: 1px solid #d1d1d1;
  border-radius: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease-out;
  color: #222;
  border-color: #d1d1d1;
  background-color: #FFF;

  &:hover {
    color: #222;
    border-color: #61DAFB;
    background-color: #61DAFB;
  }
  &:active {
    color: #61DAFB;
    border-color: #282C34;
    background-color: #282C34;
  }

  ${props => props.size === 'xl' ? Font('lg') :
             props.size === 'fullWidth' ? Font('md') :
             props.size === 'sm' ? Font('md') :
             props.size === 'xs' ? Font('sm') :
             Font(props.size)};

  &:disabled {
    color: #d1d1d1;
    border: 1px solid #dfdfdf;
    background-color: #f7f7f7;
    cursor: default;

    &:hover {
      color: #d1d1d1;
      border-color: #dfdfdf;
      background-color: #f7f7f7;
    }
    &:active {
      color: #d1d1d1;
      border-color: #dfdfdf;
      background-color: #f7f7f7;
    }
  }
`


// WEBPACK FOOTER //
// ./client/components/Styled/Button/index.js